import React, { Fragment } from 'react';
import {Modal} from 'react-bootstrap';
import AbstractComponent from '../../AbstractComponent';
import InputPassword from '../../layout/input/InputPassword';
import Button from '../../layout/button/Button';
import Alerta from '../../layout/alert/Alerta';

class ModalChangeSenha extends AbstractComponent {
    constructor(props) {
        super(props);
        
        this.state = {
            senha: '',
            
            erro: {
                message: '',
                code: 0
            },

            preload: false
        }
    }                  

    salvar() {
        this.setState({preload: true});

        this.props.service(
            this.props.id,
            this.state.senha
        ).then(() => {
            this.setState({preload: false, senha: ''});
            this.props.onSucesso();
        }).catch(erro => {
            this.setState({
                erro: this.trataErro(erro),
                preload: false
            });
        });
    }

    showComponent() {
        if(!this.props.show)
            return ;

        return (
            <Modal show={true}
                   className={this.props.className}
                   style={{zIndex: 9999}}
                   onHide={() => this.fechar()}>
                {
                    this.props.header !== "" &&
                    <Modal.Header className="bg-white"
                                  closeButton>
                        <h4>                                                        
                            {this.props.header}
                        </h4>
                    </Modal.Header>
                }                                

                <Modal.Body 
                    className="text-center text-dark" 
                    style={{marginBottom: '15px'}}
                >
                    <Alerta
                        exibir={this.state.erro.code !== 0}
                        texto={this.state.erro.message}
                        timeOut={5}

                        onTimeOut={() => this.setState({erro: this.finalizaErro(this.state.erro)})}
                    />

                    <div className="text-center bg-white"
                        style={{marginBottom: '15px'}}>
                        
                        <InputPassword
                            md={12}
                            xs={12}
                            sm={12}
                            lg={12}
                            id="senha"
                            nome="senha"
                            ref={ref => this.senha = ref}
                            defaultFoco={true}
                            value={this.state.senha}
                            
                            onChange={(e) => this.setState({senha: e.target.value})}
                        >
                            Senha
                        </InputPassword>
                    </div>                    
                                    

                    <div className="row" style={{marginTop: '30px'}}>
                        <div className="col-md-6 
                                        col-sm-6
                                        col-lg-6
                                        col-xs-6">
                            <Button                                    
                                className="text-center btn btn-primary"
                                type="button" 
                                background={3}
                                color={false}
                                disabled={this.state.preload}
                                style={{
                                    width: 'auto',
                                    minWidth: '83px',
                                    height: '45px'
                                }}                                
                                onClick={() => {this.salvar()}}
                            >
                                {(this.state.preload ? 'Aguarde...' : 'Salvar')}
                            </Button>
                        </div>

                        <div className="col-md-6 
                                        col-sm-6
                                        col-lg-6
                                        col-xs-6">
                            <Button 
                                className="text-center btn btn-danger"
                                type="button" 
                                style={{
                                    width: 'auto',
                                    minWidth: '83px',
                                    height: '45px'
                                }}
                                background={3}     
                                disabled={this.state.preload}                               
                                onClick={() => {this.props.fechar()}}
                            >
                                Cancelar
                            </Button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal> 
        );
    }

    render() {
        return (
            <Fragment>
                {this.showComponent()}
            </Fragment>          
        )
    }
}

export default ModalChangeSenha;